import { varsFromServer } from '../client_side_injection_vars';

export const logCriticalError = (message, ...args) => {
  if (varsFromServer.isProd) {
    window.Rollbar.critical(message, ...args);
  } else {
    console.error(message, ...args); // eslint-disable-line no-console
  }
};

export const logError = (message, ...args) => {
  if (varsFromServer.isProd) {
    window.Rollbar.error(message, ...args);
  } else {
    console.error(message, ...args); // eslint-disable-line no-console
  }
};

export const logSelfServeError = (message, error) => {
  if (varsFromServer.isProd || varsFromServer.logSelfServeErrors === 'true') {
    window.Rollbar.error(message, error);
  } else {
    console.error(message, error); // eslint-disable-line no-console
  }
};

export const logInfo = (message, ...args) => {
  if (varsFromServer.isProd) {
    window.Rollbar.info(message, ...args);
  } else {
    console.info(message, ...args); // eslint-disable-line no-console
  }
};

export const logWarning = (message, ...args) => {
  if (varsFromServer.isProd) {
    window.Rollbar.warning(message, ...args);
  } else {
    console.warn(message, ...args); // eslint-disable-line no-console
  }
};
